import { UsersAPI } from "api/users";
import { setTabToken } from "common/MetaActions";
import { RootState } from "store";
import { StateCreator } from "zustand";

export interface ResetPasswordSlice {
  isValid: boolean;
  tokenIsSet: boolean;
  isActivated: boolean;
  isSendingActivation?: boolean;

  sendingResetPassword: () => void;
  resetPasswordSent: () => void;
  tokenIsValid: () => void;
  passwordSet: () => void;
  validateToken: (token: string) => void;
  sendSetNewPassword: (password: string, key: string) => void;
  sendResetPassword: (email: string) => void;
}

export const createResetPasswordSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  ResetPasswordSlice
> = (set, get) => ({
  isValid: false,
  tokenIsSet: false,
  isActivated: false,

  sendingResetPassword: () =>
    set(
      ({ resetPassword }) => ({
        resetPassword: {
          ...resetPassword,
          isSendingActivation: true,
          isActivated: false
        }
      }),
      false,
      "resetPassword/SENDING_RESET_PASSWORD"
    ),

  resetPasswordSent: () =>
    set(
      ({ resetPassword }) => ({
        resetPassword: {
          ...resetPassword,
          isSendingActivation: false,
          isActivated: true
        }
      }),
      false,
      "resetPassword/RESET_PASSWORD_SENT"
    ),

  tokenIsValid: () =>
    set(
      ({ resetPassword }) => ({
        resetPassword: {
          ...resetPassword,
          isValid: true
        }
      }),
      false,
      "resetPassword/TOKEN_IS_VALID"
    ),

  passwordSet: () =>
    set(
      ({ resetPassword }) => ({
        resetPassword: {
          ...resetPassword,
          tokenIsSet: true
        }
      }),
      false,
      "resetPassword/PASSWORD_SET"
    ),

  validateToken: async (token) => {
    set({}, false, "resetPassword/VALIDATE_TOKEN");
    try {
      await UsersAPI.validateResetPasswordToken(token);
      get().resetPassword.tokenIsValid();
    } catch (error) {
      // Error already handled by errorHandlingPlugin
    }
  },

  sendSetNewPassword: async (password, key) => {
    set({}, false, "resetPassword/SEND_SET_NEW_PASSWORD");
    try {
      const token = await UsersAPI.sendSetNewPassword(password, key);
      const tokenWithoutQuotes = token.replace(/^"|"$/g, "");
      setTabToken(tokenWithoutQuotes);
      get().resetPassword.passwordSet();
    } catch (error) {
      // Error already handled by errorHandlingPlugin
    }
  },

  sendResetPassword: async (email) => {
    set({}, false, "resetPassword/SEND_RESET_PASSWORD");
    get().resetPassword.sendingResetPassword();
    try {
      await UsersAPI.sendResetPassword(email);
      get().resetPassword.resetPasswordSent();
    } catch (error) {
      // Error already handled by errorHandlingPlugin
    }
  }
});
